import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import Vant from 'vant';
import 'vant/lib/index.css';
import VueWechatTitle from 'vue-wechat-title'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import VueFullPage from 'vue-fullpage.js'
import 'swiper/swiper-bundle.css'
import {  Swiper,Navigation,Pagination, Autoplay,EffectFade } from 'swiper'
Swiper.use([Pagination, Autoplay,EffectFade,Navigation])
import VueAwesomeSwiper from 'vue-awesome-swiper'
import * as commonTool from '@/utils/common.js';

Vue.config.productionTip = false
Vue.use(Vant);
Vue.use(VueWechatTitle)
Vue.use(VueFullPage);
Vue.use(VueAwesomeSwiper,Swiper)

//登录判断
router.beforeEach((to, from, next) => {
  if (to.path === "/web/firehero" && commonTool.isPC()) {
    next();
  } else if (to.path === "/web/firehero/h5" && !commonTool.isPC()) {
    next();
  } else {
    if (commonTool.isPC()) {
      next({ path: "/web/firehero" });
    }else {
      next({ path: "/web/firehero/h5" });
    }
  }
});

if (typeof window !== "undefined") {
  window.Vue = new Vue({
    el: "#app",
    router,
    store,
    template: "<App/>",
    components: { App }
  })
}



// WEBPACK FOOTER //
// ./src/main.js